import { getTicketDetailUrl } from './mapTicketItem';
import { TICKET_COUNT_FILTER_CONFIG, TICKET_SECTION_TABS } from './constants';

export const getTicketCount = (ticketState = {}) =>
    TICKET_SECTION_TABS.reduce((total, tab) => {
        const items = ticketState?.[tab.dataKey]?.items || [];
        const config = TICKET_COUNT_FILTER_CONFIG[tab.id];
        if (!config) return total;
        const allowed = new Set(config.statuses);
        const openCount = items.filter((item) => allowed.has(item?.[config.statusKey])).length;
        return total + openCount;
    }, 0);

export const openTicketDetail = (type, ticket) => {
    const url = getTicketDetailUrl(type, ticket?.raw);
    if (!url) return;
    window.open(url, '_blank');
};
